module.exports = __webpack_public_path__ + "img/veolia.28614d9d.png";